import { lazy, Suspense, type ReactNode } from 'react'
import { createBrowserRouter, Navigate } from 'react-router'
import { AdminShell } from '@/components/layout/AdminShell'

const DashboardPage = lazy(() => import('@/features/dashboard/DashboardPage'))
const UsersPage = lazy(() => import('@/features/users/UsersPage'))
const UserDetailPage = lazy(() => import('@/features/user-detail/UserDetailPage'))
const EnterprisesPage = lazy(() => import('@/features/enterprises/EnterprisesPage'))
const EnterpriseDetailPage = lazy(() => import('@/features/enterprises/EnterpriseDetailPage'))
const CallsPage = lazy(() => import('@/features/calls/CallsPage'))
const CallDetailPage = lazy(() => import('@/features/call-detail/CallDetailPage'))
const LiveCallsPage = lazy(() => import('@/features/live-calls/LiveCallsPage'))
const ScheduledCallsPage = lazy(() => import('@/features/scheduled-calls/ScheduledCallsPage'))
const LogsPage = lazy(() => import('@/features/logs/LogsPage'))
const TemplatesPage = lazy(() => import('@/features/templates/TemplatesPage'))
const SettingsPage = lazy(() => import('@/features/settings/SettingsPage'))
const DebugPage = lazy(() => import('@/features/debug/DebugPage'))

function page(element: ReactNode) {
  return <Suspense fallback={null}>{element}</Suspense>
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AdminShell />,
    children: [
      { index: true, element: page(<DashboardPage />) },
      { path: 'users', element: page(<UsersPage />) },
      { path: 'users/:uid', element: page(<UserDetailPage />) },
      { path: 'enterprises', element: page(<EnterprisesPage />) },
      { path: 'enterprises/:id', element: page(<EnterpriseDetailPage />) },
      { path: 'calls', element: page(<CallsPage />) },
      { path: 'calls/:callSid', element: page(<CallDetailPage />) },
      { path: 'live', element: page(<LiveCallsPage />) },
      { path: 'scheduled', element: page(<ScheduledCallsPage />) },
      { path: 'logs', element: page(<LogsPage />) },
      { path: 'templates', element: page(<TemplatesPage />) },
      { path: 'settings', element: page(<SettingsPage />) },
      { path: 'debug', element: page(<DebugPage />) },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
])
